<div class="tw-bg-[#F8F9FB] tw-min-h-screen">
    <app-dashboard-wrapper>
        <div class="tw-w-full tw-min-w-[260px]">
            <h2 class="!tw-text-[20px] !tw-font-semibold !tw-mb-5">
                {{ "PROFILE.SETTINGS" | translate }}
            </h2>
            <div class="tw-flex tw-gap-3 tw-items-center tw-mb-5">
                <button
                    *ngFor="let item of mainTabsData"
                    (click)="changeCurrentTab(item.value)"
                    class="tw-py-[10px] tw-px-5 tw-rounded-full tw-text-[16px] tw-font-bold"
                    [ngClass]="{
                            'tw-bg-[#0A0A75] tw-text-white':
                                currentTab === item.value,
                            'tw-bg-[#0000001A] tw-text-[#00000066]':
                                currentTab !== item.value,
                            
                        }"
                >
                    {{ item.label | translate }}
                </button>
            </div>
        </div>
        <div class="tw-flex tw-flex-col lg:tw-flex-row tw-gap-3">
            <div
                class="lg:tw-max-w-[260px] tw-min-w-[260px] tw-w-full"
                *ngIf="currentTab === 'profile'"
            >
                <div
                    class="tw-bg-white tw-w-full tw-shadow-md tw-rounded-[10px] tw-p-5 tw-mb-5"
                >
                    <ng-container *ngIf="profileCompletionPercent < 100">
                        <h3 class="!tw-text-[16px] !tw-font-semibold !tw-mb-2">
                            {{ "DASHBOARD.COMPLETE_PROFILE" | translate }}
                        </h3>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-mb-5">
                            <span class="tw-text-[18px] tw-font-semibold"
                                >{{ profileCompletionPercent }}%</span
                            >
                            <mat-progress-bar
                                mode="determinate"
                                [value]="profileCompletionPercent"
                            ></mat-progress-bar>
                        </div>
                    </ng-container>

                    <div class="tw-flex tw-gap-2 tw-flex-col tw-w-full">
                        <div
                            *ngFor="let item of subTabsData"
                            (click)="changeCurrentProfileSubTab(item.tab)"
                            class="tw-w-full tw-border tw-border-[#D8D8D8] tw-flex tw-items-center tw-cursor-pointer tw-justify-between tw-gap-2 tw-rounded-[10px] tw-px-[10px] tw-py-4"
                            [ngClass]="{
                                'tw-bg-[#F8F8F8] tw-text-black tw-font-semibold tw-opacity-100':
                                    item.tab === currentProfileSubTab,
                                'tw-font-normal tw-opacity-70':
                                    item.tab !== currentProfileSubTab
                            }"
                        >
                            <div class="tw-flex tw-items-center tw-gap-2">
                                <mat-icon
                                    class="tw-min-w-[32px]"
                                    [ngClass]="{
                                        'tw-text-blue-600':
                                            (item.tab === 'user-info' &&
                                                item.isProfileDetailsComplete) ||
                                            (item.tab === 'business-info' &&
                                                item.isBusinessDetailsComplete),
                                        'tw-text-[#D8D8D8]':
                                            (item.tab === 'user-info' &&
                                                !item.isProfileDetailsComplete) ||
                                            (item.tab === 'business-info' &&
                                                !item.isBusinessDetailsComplete)
                                    }"
                                    >check_circle_outline</mat-icon
                                >
                                <span class="tw-max-w-[90px]">{{
                                    item.name | translate
                                }}</span>
                            </div>
                            <mat-icon
                                [ngClass]="{
                                    'tw-text-black tw-opacity-100':
                                        item.tab === currentProfileSubTab,
                                    'tw-text-[#D8D8D8]':
                                        item.tab !== currentProfileSubTab
                                }"
                                >arrow_forward</mat-icon
                            >
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="tw-bg-white tw-w-full tw-shadow-md tw-rounded-[10px] tw-px-5 tw-py-[30px] tw-mb-5"
            >
                <app-user-info-settings
                    *ngIf="
                        currentTab === 'profile' &&
                        currentProfileSubTab === 'user-info'
                    "
                    [currentProfileSubTab]="currentProfileSubTab"
                ></app-user-info-settings>
                <app-business-info-settings
                    *ngIf="
                        currentTab === 'profile' &&
                        currentProfileSubTab === 'business-info'
                    "
                ></app-business-info-settings>
                <app-reset-password-settings
                    *ngIf="currentTab === 'change-password'"
                ></app-reset-password-settings>
            </div>
        </div>
    </app-dashboard-wrapper>
</div>
